// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_2YKNf","table":"Grid-module_table_9g_KL","actions":"Grid-module_actions_P0xnE","dropdown":"Grid-module_dropdown_2eo9W","icon":"Grid-module_icon_3ZchV"};